import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Notification } from '@unified-checkout/design-system';
import { House } from '@unified-checkout/design-system/icons/index';
import { DeviceContext } from '../../../context/device';
import { INNER_ROUTES } from '../../../constants';

type AddressAnnouncementProps = {
  onClose: () => void;
};
export const AddressAnnouncement = ({ onClose }: AddressAnnouncementProps) => {
  const navigate = useNavigate();

  const { isMobile } = useContext(DeviceContext);

  return (
    <Notification
      isMobile={isMobile}
      icon={House}
      hasCloseIcon
      title="Add Address"
      hintText="No Address added"
      show
      btnsProps={[
        {
          text: 'Not now',
          size: 'md',
          variant: 'link',
          color: 'secondary',
          onClickHandler: onClose,
        },
        {
          text: '+ Add address',
          color: 'primary',
          variant: 'link',
          onClickHandler: () => {
            navigate(INNER_ROUTES.ADDRESSES);
            onClose();
          },
        },
      ]}
    />
  );
};
